/**
 * Tallow Roots small helper. No dependencies.
 * Hides the "deferred, subscription or recurring purchase" disclaimer when the page has no subscription items.
 * It only runs when <body> has the class tr-hide-recurring, which layout/theme.liquid sets when no selling plans are in view.
 * It only looks inside the product form, cart drawer and cart page, and only in the normal page DOM
 * (text inside Shopify's own embedded checkout buttons cannot be reached from a theme).
 */
(function () {
  'use strict';

  var NOTICE = /(deferred|subscription|recurring)[^.]{0,120}(authori[sz]e|charge)|(authori[sz]e)[^.]{0,120}(deferred|subscription|recurring)/i;
  var AREAS = '.product-form, product-info, cart-drawer, .cart__footer, #main-cart-footer, .cart-notification';
  var queued = false;

  function sweep() {
    queued = false;
    var areas = document.querySelectorAll(AREAS);
    areas.forEach(function (area) {
      var walker = document.createTreeWalker(area, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var parent = node.parentElement;
        if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/.test(parent.tagName)) { continue; }
        if (node.nodeValue.length < 40 || !NOTICE.test(node.nodeValue)) { continue; }
        parent.setAttribute('data-tr-recurring-notice', '');
      }
    });
  }

  function queueSweep() {
    if (!queued) {
      queued = true;
      window.setTimeout(sweep, 250);
    }
  }

  function init() {
    if (!document.body.classList.contains('tr-hide-recurring')) { return; }
    sweep();
    new MutationObserver(queueSweep).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
